<template>
    <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            d="M3 12H21M3 12C3 16.9705 7.02943 21 12 21M3 12C3 7.02943 7.02943 3 12 3M21 12C21 16.9705 16.9705 21 12 21M21 12C21 7.02943 16.9705 3 12 3M12 21C14.2512 18.5354 15.5305 15.3372 15.6 12C15.5305 8.66283 14.2512 5.46451 12 3M12 21C9.74885 18.5354 8.46952 15.3372 8.4 12C8.46952 8.66283 9.74885 5.46451 12 3"
            stroke="#30313D"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
        />
    </svg>
</template>
